module.exports = __webpack_public_path__ + "static/media/hat-cowboy-side.e9a18d71.svg";